import React from "react";
import util from "../../util/tools";
import LoadMore from "../common/LoadMore";
import commonTools from "../../../common/util/util";
import { goRoute } from "../common/js";
import Img from "react-image";
import P from "prop-types";
import { Link } from "react-router-dom";
import Toast from "../common/Toast";
import Header from "../common/Header";
import "./index.css";

export default class Home extends React.Component {
  static propTypes = {
    location: P.any,
    history: P.any,
    actions: P.any
  };

  constructor(props) {
    super(props);
    this.state = {
      curTitle: "抽奖详情",
      loading: false, //当前加载状态
      showDialog: false,
      allShow: false,
      text: "",
      infoData: {},
      is_complete: 0, //是否完成  0,未完成,1,已完成
      page: 1,
      data: [{},{}]
    };

    this.changeFun = this.changeFun.bind(this);
    this.jhFun = this.jhFun.bind(this);
    this.getInfoFun = this.getInfoFun.bind(this);
    this.showDia = this.showDia.bind(this);
    this.xxdzFun = this.xxdzFun.bind(this);
    this.saveFun = this.saveFun.bind(this);
  }

  saveFun() {
    util.ajax({
      url: "/zh/drawprize/addAddress",
      isUser: true,
      isWechatId: true,
      data: {
        ...this.state.infoData
      },
      method: "POST",
      callback: res => {
        this.setState(
          {
            text: res.result.status.msg
          },
          () => {
            setTimeout(() => {
              this.setState(
                {
                  text: ""
                },
                () => {
                  if (res.result.status.code == 0) {
                    try {
                      document.location.reload();
                    } catch (e) {}
                  }
                }
              );
            }, 2000);
          }
        );
      }
    });
  }

  xxdzFun(e) {
    const curT = e.target;
    const name = curT.getAttribute("name");
    const userInfo = this.state.infoData;
    userInfo[name] = curT.value;
    this.setState({
      infoData: userInfo
    });
  }

  showDia() {
    this.setState({
      showDialog: !this.state.showDialog
    });
  }

  getInfoFun(draw_record_id) {
    this.setState({
      allShow: false,
      infoData: { name: "", tel: "" }
    });
    util.ajax({
      url: "/zh/drawprize/viewAddress",
      isUser: true,
      isWechatId: true,
      data: {
        draw_record_id: draw_record_id
      },
      callback: res => {
        if (res.result.status.code == 0) {
          this.showDia();
          let tempData = res.result.data || {};
          let allShow = false;
          if (!!tempData["name"] && !!tempData["tel"]) {
            allShow = true;
          }
          this.setState({
            allShow: allShow,
            infoData: { ...tempData, draw_record_id: draw_record_id }
          });
        }
      }
    });
  }

  jhFun(id) {
    util.ajax({
      url: "/zh/drawprize/activeMember",
      isUser: true,
      isWechatId: true,
      data: {
        draw_record_id: id
      },
      callback: res => {
        let text = "激活成功";
        if (res.result.status.code == 0) {
        } else {
          text = "激活失败";
        }
        this.setState(
          {
            text: text
          },
          () => {
            clearTimeout(this.timer1);
            this.timer1 = setTimeout(() => {
              if (res.result.status.code == 0) {
                document.location.reload();
              }
              this.setState({
                text: ""
              });
            }, 2000);
          }
        );
      }
    });
  }

  componentDidMount() {
    document.title = this.state.curTitle;

    this.getData();
  }

  changeFun(type) {
    if (this.state.is_complete == type && !!this.state.loading) {
      return false;
    }
    this.setState(
      {
        page: 1,
        is_complete: type
      },
      () => {
        this.getData(1);
      }
    );
  }

  getData(page) {
    let num = 10;
    this.setState(
      {
        loading: true
      },
      () => {
        page = page || this.state.page;
        util.ajax({
          url: "/zh/drawprize/lists",
          isUser: true,
          isWechatId: true,
          data: {
            is_complete: this.state.is_complete,
            num: num,
            page: page
          },
          callback: res => {
            this.setState({
              loading: false
            });
            if (res.result.status.code == 0) {
              let json = res.result.data;
              let tempData = [];
              if (page > 1) {
                tempData = this.state.data;
              }
              this.setState({
                isLoad: json.length >= num,
                page: this.state.page + 1,
                data: tempData.concat(json)
              });
            }
          }
        });
      }
    );
  }

  jumpPage(){
    this.props.history.push(`/rotaryDraw`)
  }

  render() {
    return (
      <div className="rotaryList">
        <header>
          <div style={{position:'fixed',width:"100%",top:'0',zIndex:1000}}>
            <Header />
          </div>
          <nav className="menu" style={{top:'0.7rem'}}>
            <div
              className={`item ${this.state.is_complete == 0 ? "active" : ""}`}
              onClick={() => this.changeFun(0)}
            >
              待完成
            </div>
            <div
              className={`item ${this.state.is_complete == 1 ? "active" : ""}`}
              onClick={() => this.changeFun(1)}
            >
              已完成
            </div>
          </nav>
        </header>
        {
          !(!!this.state.data && this.state.data.length>0) &&
          <div className={'tips'} onClick={()=>this.jumpPage()}>
            <p>亲爱的用户</p>
            <p>您还没中奖信息，请前往抽奖～</p>
          </div>
        }
        <section className="conList" style={{paddingTop:'0.7rem'}}>
          {this.state.data.map((item, index) => (
            // 四等奖 已过期 已使用 五等奖 已过期 已使用 其他为已完成
            <div
              key={`item_${index}`}
              className={`item ${this.state.is_complete == 0 ? "" : "done"}
                ${
                  this.state.is_complete == 1
                    ? item.prize_level == 4 || item.prize_level == 5
                      ? item.status == 2
                        ? "guoqi"
                        : "shiyong"
                      : ""
                    : ""
                }
              `}
            >
              <Img className="img" src={item.prize_img} />
              <div className="title fw text-overflow">
                {item.prize_level_name}
              </div>
              <div className="con text-overflow">
                {item.prize_name}
                {this.state.is_complete == 0 &&
                  item.prize_level == 3 &&
                  item.status == 0 && <span className="paying">充值中</span>}
              </div>
              {/* 手机 */}
              {this.state.is_complete == 0 &&
                item.prize_level == 1 &&
                item.status == 0 && (
                  <Link to={`cj1/${item.draw_record_id}`} className="btn btn1">
                    查看详情
                  </Link>
                )}
              {/* 拉杆箱 */}
              {this.state.is_complete == 0 &&
                item.prize_level == 2 &&
                item.status == 0 && (
                  <Link to="wuliulist" className="btn btn1">
                    查看详情
                  </Link>
                )}
              {/* 话费充值 */}
              {this.state.is_complete == 0 &&
                item.prize_level == 3 &&
                item.status == 0 && (
                  <div
                    className="btn btn1"
                    onClick={() => this.getInfoFun(item.draw_record_id)}
                  >
                    查看详情
                  </div>
                )}
              {/* 免费阅读时间 */}
              {this.state.is_complete == 0 &&
                item.prize_level == 4 &&
                item.status == 0 && (
                  <div
                    onClick={() => this.jhFun(item.draw_record_id)}
                    className="btn btn1"
                  >
                    立即激活
                  </div>
                )}
              {this.state.is_complete == 0 &&
                item.prize_level == 4 &&
                item.status == 1 && <div className="btn">使用中</div>}
              {/* {this.state.is_complete==0 && item.prize_level == 4 && item.status == 3 && <div className="btn">已激活</div>} */}
              {/* 现金充值券 */}
              {this.state.is_complete == 0 &&
                item.prize_level == 5 &&
                item.status == 0 && (
                  <Link to="recharge?type=1" className="btn btn1">
                    立即使用
                  </Link>
                )}
              {item.tips && (
                <div className="date text-overflow">{item.tips}</div>
              )}
              {item.prompt && (
                <div className="tip text-overflow">{item.prompt}</div>
              )}
            </div>
          ))}
        </section>
        {this.state.isLoad && <LoadMore loadMoreData={() => this.getData()} />}
        <Toast text={this.state.text} key="3" />
        {/* 手机号填写信息 */}
        {!!this.state.showDialog && (
          <div className="phoneDialog">
            <div className="phoneCon">
              <div className="closeBtn" onClick={this.showDia}>
                关闭
              </div>
              <div className="title">请填写个人信息</div>
              <div className="item" data-title="手机号">
                <input
                  type="text"
                  onChange={this.xxdzFun}
                  className="txt"
                  name="tel"
                  value={this.state.infoData.tel}
                />
              </div>
              <div className="item mt20" data-title="姓　名">
                <input
                  type="text"
                  onChange={this.xxdzFun}
                  className="txt"
                  name="name"
                  value={this.state.infoData.name}
                />
              </div>
              {
                !this.state.allShow &&
                <div className="enterBtn" onClick={this.saveFun}>
                  确定
                </div>
              }
            </div>
          </div>
        )}
      </div>
    );
  }
}
